<script setup lang="ts">
import { computed } from "vue";
import Icon from "./Icon.vue";

const props = withDefaults(
  defineProps<{
    variant?: "primary" | "secondary" | "outline" | "ghost" | "danger";
    size?: "sm" | "md" | "lg";
    icon?: string;
    iconAfter?: string;
    block?: boolean;
    disabled?: boolean;
    href?: string;
  }>(),
  { variant: "primary", size: "md" },
);
defineEmits<{ click: [MouseEvent] }>();

const tag = computed(() => (props.href ? "a" : "button"));
const cls = computed(() => [
  "cw-btn",
  `cw-btn--${props.variant}`,
  `cw-btn--${props.size}`,
  props.block ? "cw-btn--block" : "",
]);
const glyph = computed(() => (props.size === "sm" ? 15 : props.size === "lg" ? 20 : 18));
</script>
<template>
  <component
    :is="tag"
    :class="cls"
    :href="href"
    :type="href ? undefined : 'button'"
    :disabled="href ? undefined : disabled"
    :aria-disabled="disabled || undefined"
    @click="$emit('click', $event)"
  >
    <Icon
      v-if="icon"
      :name="icon"
      :size="glyph"
    />
    <slot />
    <Icon
      v-if="iconAfter"
      :name="iconAfter"
      :size="glyph"
    />
  </component>
</template>
